<template>
  <TabPanel
    :value="value"
    :as="as"
    :as-child="asChild"
    :unstyled="true"
    :pt="passThrough"
    class="meridia-tab-panel"
    v-bind="$attrs"
  >
    <KeepAlive v-if="keepAliveRef?.value">
      <slot />
    </KeepAlive>
    <template v-else>
      <slot />
    </template>
  </TabPanel>
</template>

<script setup lang="ts">
import { computed, inject, type Ref } from 'vue';
import TabPanel from 'primevue/tabpanel';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import type { TabPanelPassThroughOptions } from 'primevue/tabpanel';
import type { MeridiaTabPanelProps } from 'src/design_system/components/tab/types';

const props = defineProps<MeridiaTabPanelProps>();

const keepAliveRef = inject<Ref<boolean>>('meridiaTabPanelsKeepAlive');

const defaultPt: TabPanelPassThroughOptions = {
  root: {
    class: 'meridia-tab-panel-root flex flex-col flex-1 overflow-hidden min-h-0 p-0',
  },
};

const passThrough = computed(() =>
  usePassThrough(
    props.pt,
    defaultPt,
    { mergeSections: false, mergeProps: true }
  ) as PassThrough<TabPanelPassThroughOptions>
);
</script>
